import { Box, Button, Text, useMediaQuery } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { paginationItems } from '../../../../../utils/components/paginate';

export type PaginationProps = {
  currentPage: number;
  lastPage: number;
  maxLength: number;
  setCurrentPage: (page: number) => void;
  totalData: any;
};

export const PaginateDot = ({
  currentPage,
  lastPage,
  maxLength,
  setCurrentPage,
  totalData
}: PaginationProps) => {
  const pageNums = paginationItems(currentPage, lastPage, maxLength);

  const [indicador, setIndicador] = useState(1);
  const [start, setStart] = useState(1);
  const [isMobile] = useMediaQuery('(max-width: 920px)');
  const [end, setEnd] = useState(5);
  const prevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const changePage = (page: number) => {
    setIndicador(currentPage);
    setCurrentPage(page);
  };

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  useEffect(() => {
    setStart(totalData?.length === 0 ? 0 : 1);
    setEnd(totalData?.length < +maxLength ? totalData?.length : +maxLength);
  }, [totalData]);

  useEffect(() => {
    if (currentPage > indicador) {
      setStart(maxLength + 1);
      const calculateEnd = end + +maxLength;
      setEnd(
        calculateEnd > totalData?.length ? totalData?.length : calculateEnd
      );

      return;
    } else if (currentPage < indicador) {
      setStart(start - maxLength);

      const calculateEnd = end - +maxLength;
      setEnd(calculateEnd < totalData?.length ? +maxLength : calculateEnd);

      return;
    }
  }, [currentPage]);

  return (
    <>
      <div className="tw-flex tw-items-center">
        {!isMobile && (
          <p>{/* Exibindo {start} até {end} de {totalData.length} */}</p>
        )}
        <Button disabled={currentPage === 1} variant="ghost" onClick={prevPage}>
          {'<'}
        </Button>
        {pageNums.map((pageNum, idx) => (
          <Button
            key={idx}
            bg={currentPage === pageNum ? '#FF5000' : 'transparent'}
            color={currentPage === pageNum ? '#fff' : '#323232'}
            variant="ghost"
            disabled={isNaN(pageNum)}
            _hover={{
              opacity: '.8'
            }}
            onClick={() => {
              changePage(pageNum);
            }}
          >
            {!isNaN(pageNum) ? pageNum : '...'}
          </Button>
        ))}
        <Button
          disabled={currentPage === lastPage}
          variant="ghost"
          onClick={nextPage}
        >
          {'>'}
        </Button>
      </div>
    </>
  );
};
